import React, {memo} from "react";
import {NavLink} from "react-router-dom";
import {SecondLevelNavigationItem} from "../../views/LayoutStandard/types";

const SecondLevelNavigation = ({
    secondLevelNavigationItems,
}: {
    secondLevelNavigationItems?: Array<SecondLevelNavigationItem>;
}) => {
    if (!secondLevelNavigationItems) {
        return null;
    }

    return (
        <>
            {secondLevelNavigationItems.map((item) => {
                // Geschwister-Links, die unterhalb dieses Links liegen (spezifischer sind).
                // Beispiel: "Alle Zertifikate" -> /badges, "Zertifikate zuweisen" -> /badges/assign.
                // Ohne diese Pruefung wuerde der Prefix-Link (/badges) auch auf der
                // spezifischeren Route (/badges/assign) als aktiv markiert.
                const moreSpecificSiblingLinks = secondLevelNavigationItems
                    .filter((other) => other.key !== item.key && other.link.startsWith(item.link + "/"))
                    .map((other) => other.link);

                return (
                    <NavLink
                        key={item.key}
                        to={item.link}
                        isActive={(match, location) =>
                            !!match &&
                            !moreSpecificSiblingLinks.some(
                                (sibling) =>
                                    location.pathname === sibling ||
                                    location.pathname.startsWith(sibling + "/"),
                            )
                        }
                    >
                        {item.label}
                    </NavLink>
                );
            })}
        </>
    );
};

export default memo(SecondLevelNavigation);
